import React from 'react';
import PartnerContainer from '../../containers/partnermng/PartnerContainer';

const PartnerViewPage = () => {
  return <PartnerContainer />;
};

export default PartnerViewPage;
